module.exports = __webpack_public_path__ + "static/media/olake-saas.4dd75f3d.svg";